import { render, staticRenderFns } from "./owner_yukon.vue?vue&type=template&id=58e1ef90&"
import script from "./owner_yukon.vue?vue&type=script&lang=js&"
export * from "./owner_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports